export default {
  // ALL PAGES
  DZ_BLOG_PAGE_TIME_SPENT: 'DZ_BLOG_PAGE_TIME_SPENT', // With timer value
  DZ_RF_PAGE_TIME_SPENT: 'DZ_RF_PAGE_TIME_SPENT', // With timer value
  DZ_MM_PAGE_TIME_SPENT: 'DZ_MM_PAGE_TIME_SPENT', // With timer value
  // HOME PAGE
  DZ_HOME_LAND: 'DZ_HOME_LAND',
  DZ_HOME_RF_ITEM_TAP: 'DZ_HOME_RF_ITEM_TAP', // WITH ID PARAM
  DZ_HOME_MM_ITEM_TAP: 'DZ_HOME_MM_ITEM_TAP', // WITH ID PARAM
  DZ_HOME_BLOG_ITEM_TAP: 'DZ_HOME_BLOG_ITEM_TAP', // blog id
  DZ_HOME_BLOG_ITEMS_SWIPE: 'DZ_HOME_BLOG_ITEMS_SWIPE',
  DZ_HOME_SIGNUP_CTA_TAP: 'DZ_HOME_SIGNUP_CTA_TAP',
  DZ_RF_TAKE_QUIZ_CTA_TAP: 'DZ_RF_TAKE_QUIZ_CTA_TAP',
  DZ_MM_TAKE_QUIZ_CTA_TAP: 'DZ_MM_TAKE_QUIZ_CTA_TAP',
  DZ_HOME_RR_BTN_TAP: 'DZ_HOME_RR_BTN_TAP',
  // RF PAGE
  DZ_RF_LAND: 'DZ_RF_LAND', // WITH ACTIVITY TYPE OR ID
  DZ_RF_NEXT_CTA_TAP: 'DZ_RF_NEXT_CTA_TAP',
  DZ_RF_VIDEO_START: 'DZ_RF_VIDEO_START',
  DZ_RF_VIDEO_END: 'DZ_RF_VIDEO_END',
  DZ_RF_BACK_BTN_TAP: 'DZ_RF_BACK_BTN_TAP',
  DZ_RF_GET_CERTIFIED_BTN_TAP: 'DZ_RF_GET_CERTIFIED_BTN_TAP',
  // MM PAGE
  DZ_MM_LAND: 'DZ_MM_LAND',
  DZ_MM_GET_CERTIFIED_BTN_TAP: 'DZ_MM_GET_CERTIFIED_BTN_TAP',
  // QUIZ
  DZ_RF_QUIZ_LAND: 'DZ_RF_QUIZ_LAND',
  DZ_MM_QUIZ_LAND: 'DZ_MM_QUIZ_LAND',
  DZ_RF_QUIZ_SELECT_OPTION: 'DZ_RF_QUIZ_SELECT_OPTION',
  DZ_MM_QUIZ_SELECT_OPTION: 'DZ_MM_QUIZ_SELECT_OPTION',
  DZ_RF_QUIZ_BACK_TAP: 'DZ_RF_QUIZ_BACK_TAP',
  DZ_MM_QUIZ_BACK_TAP: 'DZ_MM_QUIZ_BACK_TAP',
  // QUIZ FEEDBACK
  DZ_RF_QUIZ_FEEDBACK_LAND: 'DZ_RF_QUIZ_FEEDBACK_LAND',
  DZ_MM_QUIZ_FEEDBACK_LAND: 'DZ_MM_QUIZ_FEEDBACK_LAND',
  DZ_QUIZ_FEEDBACK_VIEW_INCORRECT_ANSWERS_TAP: 'DZ_QUIZ_FEEDBACK_VIEW_INCORRECT_ANSWERS_TAP',
  DZ_QUIZ_FEEDBACK_QUIT_BTN_TAP: 'DZ_QUIZ_FEEDBACK_QUIT_BTN_TAP',
  DZ_QUIZ_FEEDBACK_DOIT_LATER_BTN_TAP: 'DZ_QUIZ_FEEDBACK_DOIT_LATER_BTN_TAP',
  // QUIZ RESULTS
  DZ_RF_QUIZ_RESULTS_LAND: 'DZ_RF_QUIZ_RESULTS_LAND',
  DZ_MM_QUIZ_RESULTS_LAND: 'DZ_MM_QUIZ_RESULTS_LAND',
  DZ_QUIZ_RESULTS_VIEW_ALL_TAP: 'DZ_QUIZ_RESULTS_VIEW_ALL_TAP',
  DZ_RF_QUIZ_RESULTS_TAKE_TEST_AGAIN_TAP: 'DZ_RF_QUIZ_RESULTS_TAKE_TEST_AGAIN_TAP',
  DZ_MM_QUIZ_RESULTS_TAKE_TEST_AGAIN_TAP: 'DZ_MM_QUIZ_RESULTS_TAKE_TEST_AGAIN_TAP',
  // Recycle RIGHT PAGE
  DZ_RR_CLOSE_TAP: 'DZ_RR_CLOSE_TAP',
  DZ_RR_ANSWER: 'DZ_RR_ANSWER',
  DZ_RR_TIMEOUT: 'DZ_RR_TIMEOUT',
  DZ_RR_TIMEOUT_RESTART_LEVEL_BTN_TAP: 'DZ_RR_TIMEOUT_RESTART_LEVEL_BTN_TAP',
  DZ_RR_TIMEOUT_CONTINUE: 'DZ_RR_TIMEOUT_CONTINUE',
  DZ_RR_LEVEL_FAIL: 'DZ_RR_LEVEL_FAIL',
  DZ_RR_LEVEL_SUCCESS: 'DZ_RR_LEVEL_SUCCESS',
  DZ_RR_LEVEL_SUMMARY_SHOW_MORE_TAP: 'DZ_RR_LEVEL_SUMMARY_SHOW_MORE_TAP',
  DZ_RR_LEVEL_SUMMARY_RESTART_BTN_TAP: 'DZ_RR_LEVEL_SUMMARY_RESTART_BTN_TAP',
  DZ_RR_LEVEL_SUMMARY_NEXT_BTN_TAP: 'DZ_RR_LEVEL_SUMMARY_NEXT_BTN_TAP',
  DZ_RR_FINISHED_PLAY_AGAIN_BTN_TAP: 'DZ_RR_FINISHED_PLAY_AGAIN_BTN_TAP',
  DZ_RR_LAND: 'DZ_RR_LAND',
};
